import './FileSizeComponent.css';

import React from 'react';
import { generateClassName } from '../../../b2b-common/helpers';

const formatBytes = (bytes) => {
    if (bytes === 0) return { figure: 0, unit: 'Bytes' };
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const figure = Math.round(bytes / Math.pow(k, i));
    const unit = sizes[i];
    return { figure, unit };
};

const FileSizeComponent = ({ size, className = null }) => {
    const { figure, unit } = formatBytes(size);
    return (
        <div className={generateClassName('file-size-component', '', className)}>
            <div className="file-size-figure">
                {figure}
            </div>
            <div className="file-size-unit">
                {unit}
            </div>
        </div>
    );
};

export default FileSizeComponent;